import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-alert-note',
  templateUrl: './alert-note.component.html',
  styleUrls: ['./alert-note.component.scss']
})
export class AlertNoteComponent implements OnInit {

  @Input() initialText: string = '';
  @Input() highlightText: string = '';
  @Input() finalText: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
